// The quest's pumpkins as inline SVG: dark and carved until a haunt counts, then lit from inside.

const NS = "http://www.w3.org/2000/svg";

function el(tag: string, attrs: Record<string, string>): SVGElement {
  const e = document.createElementNS(NS, tag);
  for (const [k, v] of Object.entries(attrs)) e.setAttribute(k, v);
  return e;
}

export function pumpkinIcon(lit: boolean): SVGElement {
  const svg = el("svg", { viewBox: "0 0 120 110", class: `oh-pumpkin${lit ? " lit" : ""}`, "aria-hidden": "true", focusable: "false" });
  svg.append(
    el("path", { class: "stem", d: "M58 22c0-8 3-14 9-18l5 4c-4 3-6 8-6 14z" }),
    el("ellipse", { class: "rind", cx: "36", cy: "62", rx: "26", ry: "36" }),
    el("ellipse", { class: "rind", cx: "84", cy: "62", rx: "26", ry: "36" }),
    el("ellipse", { class: "rind mid", cx: "60", cy: "62", rx: "30", ry: "40" }),
    el("path", { class: "face", d: "M36 50l12-10 8 12zM84 50l-12-10-8 12zM60 58l-6 10h12z" }),
    el("path", { class: "face", d: "M30 74c10 14 50 14 60 0l-8 3-5 6-6-5-6 6-6-6-6 5-5-6z" }),
  );
  return svg;
}
